<template>
    <div class="enterise-detail-container">
        <div class="top-container">
            <!-- 企业基本信息 -->
            <div class="header-left">
                <div class="title-container">
                    <span class="prefix-line"></span>
                    <span class="title-font">{{ enterpriseInfo.name }}</span>
                </div>
                <div class="field-container">
                    <div class="field-row">
                        <div>
                            行业类别：<span>{{ enterpriseInfo.industryName }}</span>
                        </div>
                        <div>
                            法&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;人：<span>{{ enterpriseInfo.legalPerson }} {{ enterpriseInfo.legalPhone }}</span>
                        </div>
                        <div>
                            统一社会信用代码：<span>{{ enterpriseInfo.organizationCode }}</span>
                        </div>
                    </div>
                    <div class="field-row">
                        <div>
                            企业规模：<span>{{ enterpriseInfo.scaleName }}</span>
                        </div>
                        <div>
                            联&nbsp;&nbsp;系&nbsp;&nbsp;人：<span>{{ enterpriseInfo.contactPerson }} {{ enterpriseInfo.contactPhone }}</span>
                        </div>
                        <div>
                            产废总量：<span>{{ enterpriseInfo.totalManufacture }}(kg)</span>
                        </div>
                    </div>
                    <div class="field-row">
                        <div>
                            <span class="long-text-span" :title="enterpriseInfo.address">详细地址：{{ enterpriseInfo.address }}</span>
                        </div>
                        <div>
                            环保专员：<span>{{ enterpriseInfo.envProtectPerson }}
                                {{ enterpriseInfo.envProtectPhone }}</span>
                        </div>
                        <div>
                            库存总量：<span>{{ enterpriseInfo.totalStorage }}(kg)</span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 监控视频 -->
            <div class="header-right">
                <div class="title-container">
                    <span class="prefix-line"></span>
                    <span class="title-font">监控视频</span>
                </div>
                <div class="video-container">
                    <div v-if="cameraList && cameraList.length > 0" style="display: contents">
                        <div v-for="item in cameraList" :key="item.ioTDeviceId">
                            <div class="video-item" @click="openVideo(item)">
                                <img src="../../assets/image/camera1.png" />
                                <div class="videl-title">{{ item.description }}</div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="video-item">
                            <img src="../../assets/image/camera4.png" />
                            <div class="videl-title">暂未安装</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom-container">
            <div class="tab-header">
                <div class="tab-item" :class="{ 'tab-item-active': tabIndex === 0 }" @click="changeTab(0)">
                    <span>产废类别</span>
                </div>
                <div class="tab-devider"></div>
                <div class="tab-item" :class="{ 'tab-item-active': tabIndex === 1 }" @click="changeTab(1)">
                    <span>危废库房</span>
                </div>
                <div class="tab-devider"></div>
                <div class="tab-item" :class="{ 'tab-item-active': tabIndex === 2 }" @click="changeTab(2)">
                    <span>报警信息</span>
                </div>
                <div class="tab-devider"></div>
                <div class="tab-item" :class="{ 'tab-item-active': tabIndex === 3 }" @click="changeTab(3)">
                    <span>联单信息</span>
                </div>
                <div class="tab-devider"></div>
                <div class="tab-item" :class="{ 'tab-item-active': tabIndex === 4 }" @click="changeTab(4)">
                    <span>产废环比</span>
                </div>
                <div class="tab-devider"></div>
                <div class="tab-item" :class="{ 'tab-item-active': tabIndex === 5 }" @click="changeTab(5)">
                    <span>产废流向</span>
                </div>
                <div class="tab-devider"></div>
                <div class="tab-item" :class="{ 'tab-item-active': tabIndex === 6 }" @click="changeTab(6)">
                    <span>产废预测</span>
                </div>
                <div class="tab-devider"></div>
                <div class="tab-item" :class="{ 'tab-item-active': tabIndex === 7 }" @click="changeTab(7)">
                    <span>危废生命期</span>
                </div>
                <div class="tab-devider"></div>
                <div class="tab-item" :class="{ 'tab-item-active': tabIndex === 8 }" @click="changeTab(8)">
                    <span>抓拍图像</span>
                </div>
                <div class="tab-devider"></div>
                <div class="tab-item" :class="{ 'tab-item-active': tabIndex === 9 }" @click="changeTab(9)">
                    <span>汇总台账</span>
                </div>
            </div>
            <div class="tab-container">
                <!-- 产废类别 -->
                <div class="tab-chart" v-show="tabIndex == 0">
                    <Enterprise-Hw-Type />
                </div>
                <!-- 危废库房 -->
                <div class="tab-store" v-show="tabIndex == 1">
                    <div class="store-left">
                        <div class="tab-body-header">库房信息</div>
                        <div class="store-body">
                            <table>
                                <tbody>
                                    <tr>
                                        <td style="text-align: right; width: 200px">名称：</td>
                                        <td>{{ storeHouse.name }}</td>
                                    </tr>
                                    <tr>
                                        <td style="text-align: right; width: 200px">面积：</td>
                                        <td>{{ storeHouse.area }}㎡</td>
                                    </tr>
                                    <tr>
                                        <td style="text-align: right; width: 200px">环境温度：</td>
                                        <td>{{ storeHouse.envTemperature }}°C</td>
                                    </tr>
                                    <tr>
                                        <td style="text-align: right;width: 200px">环境湿度：</td>
                                        <td>{{ storeHouse.envHumidity }}%</td>
                                    </tr>
                                    <tr>
                                        <td style="text-align: right;width: 200px">设备温度：</td>
                                        <td>{{ storeHouse.deviceTemperature }}°C</td>
                                    </tr>
                                    <tr>
                                        <td style="text-align: right;width: 200px">一体机状态：</td>
                                        <td>{{ this.enum.deviceStatus.getLabel(storeHouse.tabletStatus) }}</td>
                                    </tr>
                                    <tr>
                                        <td style="text-align: right;width: 200px">打印机状态：</td>
                                        <td>{{ this.enum.deviceStatus.getLabel(storeHouse.printerStatus) }}</td>
                                    </tr>
                                    <tr>
                                        <td style="text-align: right;width: 200px">电子秤状态：</td>
                                        <td>{{ this.enum.deviceStatus.getLabel(storeHouse.electronicScalesStatus) }}</td>
                                    </tr>
                                    <tr>
                                        <td style="text-align: right;width: 200px">摄像头状态：</td>
                                        <td>{{ this.enum.deviceStatus.getLabel(storeHouse.cameraStatus) }}</td>
                                    </tr>
                                    <tr>
                                        <td style="text-align: right;width: 200px">门禁感应状态：</td>
                                        <td>{{ this.enum.deviceStatus.getLabel(storeHouse.doorSensorStatus) }}</td>
                                    </tr>
                                    <tr>
                                        <td style="text-align: right;width: 200px">人体感应状态：</td>
                                        <td>{{ this.enum.bodySensorStatus.getLabel(storeHouse.bodySensorStatus) }}</td>
                                    </tr>
                                    <tr>
                                        <td style="text-align: right;width: 200px">声光报警器状态：</td>
                                        <td>{{ this.enum.deviceStatus.getLabel(storeHouse.soundLightAlarmStatus) }}</td>
                                    </tr>
                                    <tr>
                                        <td style="text-align: right;width: 200px">最后通信时间：</td>
                                        <td>{{ storeHouse.lastHeartbeatTime }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="store-right">
                        <div class="tab-body-header">库存信息</div>
                        <div style="flex:auto">
                            <vxe-table show-overflow highlight-hover-row highlight-current-row auto-resize border="none" height="100%" :data="hwTypeList" class="mytable-scrollbar">
                                <vxe-table-column type="seq" width="60"></vxe-table-column>
                                <vxe-table-column field="hwCode1" width="80" title="危废种类" show-overflow="title"></vxe-table-column>
                                <vxe-table-column field="alias" width="220" title="俗称" show-overflow="title"></vxe-table-column>
                                <vxe-table-column field="hwCode2" width="100" title="危废代码" show-overflow="title"></vxe-table-column>
                                <vxe-table-column field="hwName2" title="代码名称" show-overflow="title"></vxe-table-column>
                                <vxe-table-column field="inventory" width="150" align="center" title="暂存量(kg)" show-overflow="title"></vxe-table-column>
                                <vxe-table-column field="inStorageYTD" width="150" align="center" title="当年入库量(kg)" show-overflow="title"></vxe-table-column>
                                <vxe-table-column field="inStorage" width="150" align="center" title="累计入库量(kg)" show-overflow="title"></vxe-table-column>
                            </vxe-table>
                        </div>
                    </div>
                </div>
                <!-- 报警信息 -->
                <div class="tab-alarm" v-show="tabIndex == 2">
                    <div class="alarm-left">
                        <div class="tab-body-header">报警消息</div>
                        <div style="flex:auto">
                            <vxe-table show-overflow highlight-hover-row highlight-current-row auto-resize border="none" class="mytable-scrollbar" height="100%" :data="alarmList"
                                empty-text="暂无数据！" @cell-click="alarmClickEvent">
                                <vxe-table-column type="seq" width="60"></vxe-table-column>
                                <vxe-table-column field="alarmType" width="140" formatter="formatAlarmType" title="报警类型" show-overflow="title"></vxe-table-column>
                                <vxe-table-column field="content" title="报警内容" show-overflow="title"></vxe-table-column>
                                <vxe-table-column field="createdTime" width="150" title="报警时间" show-overflow="title"></vxe-table-column>
                            </vxe-table>
                        </div>
                    </div>
                    <div class="alarm-right">
                        <div class="tab-body-header">报警状态</div>
                        <div v-if="currentAlarm">
                            <Step :dataSource="alarmStatus" type="check" />
                            <div class="tab-body-header">处理日志</div>
                            <Step :dataSource="alarmLogs" direction="v" class="mytable-scrollbar" />
                        </div>
                        <div v-else>
                            <div style="line-height:580px; text-align:center; font-size: 14px;">暂无数据!</div>
                        </div>
                    </div>
                </div>
                <!-- 联单信息 -->
                <div class="tab-manifest" v-show="tabIndex == 3">
                    <div class="manifest-left">
                        <div class="tab-body-header">联单信息</div>
                        <div style="flex:auto">
                            <vxe-table show-overflow highlight-hover-row highlight-current-row auto-resize border="none" class="mytable-scrollbar" height="100%"
                                :data="manifestList" empty-text="暂无数据！" @cell-click="manifestClickEvent">
                                <vxe-table-column type="seq" width="40"></vxe-table-column>
                                <vxe-table-column field="manifestCode" width="140" title="联单编号" show-overflow="title"></vxe-table-column>
                                <vxe-table-column field="transportOrganizationName" width="200" title="运输企业" show-overflow="title"></vxe-table-column>
                                <vxe-table-column field="truckLicensePlateNumber" title="运输车辆" show-overflow="title"></vxe-table-column>
                                <!-- <vxe-table-column field="lifeCycle" title="联单类型" formatter="formatLifeCycleType" show-overflow="title"></vxe-table-column> -->
                                <vxe-table-column field="weightOfEmptyCar" title="空车重量(kg)" align="center" show-overflow="title"></vxe-table-column>
                                <vxe-table-column field="weightOfFullCar" title="载货重量(kg)" align="center" show-overflow="title"></vxe-table-column>
                                <vxe-table-column field="actualTransferWeight" width="120" title="实际转移量(kg)" align="center" show-overflow="title"></vxe-table-column>
                                <vxe-table-column field="transportDistance" title="运输距离(km)" align="center" show-overflow="title"></vxe-table-column>
                                <vxe-table-column title="操作" width="150">
                                    <template #default="{ row }">
                                        <template v-if="row.lifeCycle >= 8">
                                            <a @click="openTrack(row)">查看轨迹 </a>
                                        </template>
                                        <template v-if="row.hwSourceIds && row.hwSourceIds.length > 0">
                                            <a @click="openSource(row)"> 查看来源</a>
                                        </template>
                                    </template>
                                </vxe-table-column>
                            </vxe-table>
                        </div>
                    </div>
                    <div class="manifest-right">
                        <div class="tab-body-header">联单状态</div>
                        <div v-if="currentManifest">
                            <Step :dataSource="manifestStatus" type="check" />
                            <div class="tab-body-header">联单日志</div>
                            <Step :dataSource="manifestLogs" direction="v" class="mytable-scrollbar" />
                        </div>
                        <div v-else>
                            <div style="line-height:580px; text-align:center; font-size: 14px;">暂无数据!</div>
                        </div>
                    </div>
                </div>
                <!-- 产废环比 -->
                <div class="tab-chart" v-show="tabIndex == 4">
                    <Enterprise-Comparison />
                </div>
                <!-- 产废流向 -->
                <div class="tab-chart" v-show="tabIndex == 5">
                    <Enterprise-Flow-Direction />
                </div>
                <!-- 产废预测 -->
                <div class="tab-chart" v-show="tabIndex == 6">
                    <Enterprise-Forecast />
                </div>
                <!-- 危废生命期 -->
                <div class="tab-life" v-show="tabIndex == 7">
                    <div class="life-left">
                        <vxe-table show-overflow highlight-hover-row highlight-current-row auto-resize border="none" class="mytable-scrollbar" height="100%" :data="hwTypeList"
                            empty-text="暂无数据！" @cell-click="lifeClickEvent" ref="xTable">
                            <vxe-table-column type="seq" width="60"></vxe-table-column>
                            <vxe-table-column width="80" field="hwCode1" title="危废代码" show-overflow="title"></vxe-table-column>
                            <vxe-table-column width="100" field="hwCode2" title="种类代码" show-overflow="title"></vxe-table-column>
                            <vxe-table-column field="alias" title="种类名称" show-overflow="title"></vxe-table-column>
                            <vxe-table-column width="100" align="center" field="inventory" title="暂存量(kg)" show-overflow="title"></vxe-table-column>
                        </vxe-table>
                    </div>
                    <div class="life-right">
                        <div class="life-right-header">
                            <div class="life-right-header-btn1" @click="changeLife(0)" :class="{ 'life-btn-active': lifeIndex == 0 }">
                                产生
                            </div>
                            <div class="life-right-header-icon">➠</div>
                            <div class="life-right-header-btn2" @click="changeLife(1)" :class="{ 'life-btn-active': lifeIndex == 1 }">
                                贮存
                            </div>
                            <div class="life-right-header-icon">➠</div>
                            <div class="life-right-header-btn3" @click="changeLife(2)" :class="{ 'life-btn-active': lifeIndex == 2 }">
                                转移
                            </div>
                            <div class="life-right-header-icon">➠</div>
                            <div class="life-right-header-btn4" @click="changeLife(3)" :class="{ 'life-btn-active': lifeIndex == 3 }">
                                处置
                            </div>
                        </div>
                        <div>
                            <Enterprise-Flow-Chart />
                        </div>
                    </div>
                </div>
                <!-- 抓拍图像 -->
                <div class="tab-images" v-show="tabIndex == 8">
                    <div v-for="item in imageList" :key="item.cameraSnapshotId">
                        <div class="image-item" @click="imageView(item.imageUrl)">
                            <img v-bind:src="item.imageUrl" />
                        </div>
                    </div>
                </div>
                <!-- 汇总台账 -->
                <div class="tab-life" v-show="tabIndex == 9">
                    <div class="life-right">
                        <div class="life-right-header">
                            <div class="life-right-header-btn1" @click="changeStandingBook(0)" :class="{ 'life-btn-active': standingBookIndex == 0 }">
                                入库
                            </div>
                            <div class="life-right-header-icon">➠</div>
                            <div class="life-right-header-btn2" @click="changeStandingBook(1)" :class="{ 'life-btn-active': standingBookIndex == 1 }">
                                转移
                            </div>
                            <div class="life-right-header-icon">➠</div>
                            <div class="life-right-header-btn3" @click="changeStandingBook(2)" :class="{ 'life-btn-active': standingBookIndex == 2 }">
                                处置
                            </div>
                        </div>
                        <div class="life-right-content">
                            <vxe-table v-if="standingBookIndex == 0" show-overflow highlight-hover-row highlight-current-row auto-resize border="none" class="mytable-scrollbar"
                                height="100%" :data="standingBookList1" empty-text="暂无数据！">
                                <vxe-table-column type="seq" width="60"></vxe-table-column>
                                <vxe-table-column field="hwCode1" title="危废类别" show-overflow="title"></vxe-table-column>
                                <vxe-table-column field="hwCode2" title="危废代码" show-overflow="title"></vxe-table-column>
                                <vxe-table-column field="alias" title="危废俗称" show-overflow="title"></vxe-table-column>
                                <vxe-table-column field="amount" title="入库量(kg)" show-overflow="title"></vxe-table-column>
                                <vxe-table-column field="lastDate" title="最后入库日期" show-overflow="title"></vxe-table-column>
                            </vxe-table>
                            <vxe-table v-if="standingBookIndex == 1" show-overflow highlight-hover-row highlight-current-row auto-resize border="none" class="mytable-scrollbar"
                                height="100%" :data="standingBookList2" empty-text="暂无数据！">
                                <vxe-table-column type="seq" width="60"></vxe-table-column>
                                <vxe-table-column field="transportOrganizationName" title="转移企业" show-overflow="title"></vxe-table-column>
                                <vxe-table-column field="truckLicensePlateNumber" title="运输车辆" show-overflow="title"></vxe-table-column>
                                <vxe-table-column field="driverName" title="驾驶员姓名" show-overflow="title"></vxe-table-column>
                                <vxe-table-column field="driverPhone" title="驾驶员电话" show-overflow="title"></vxe-table-column>
                                <vxe-table-column field="actualTransferWeight" title="转移量(kg)" show-overflow="title"></vxe-table-column>
                                <vxe-table-column field="transportEndTime" title="转移时间" show-overflow="title"></vxe-table-column>
                            </vxe-table>
                            <vxe-table v-if="standingBookIndex == 2" show-overflow highlight-hover-row highlight-current-row auto-resize border="none" class="mytable-scrollbar"
                                height="100%" :data="standingBookList3" empty-text="暂无数据！">
                                <vxe-table-column type="seq" width="60"></vxe-table-column>
                                <vxe-table-column field="disposalOrganizationName" title="处置企业" show-overflow="title"></vxe-table-column>
                                <vxe-table-column field="actualTransferWeight" title="处置量(kg)" show-overflow="title"></vxe-table-column>
                                <vxe-table-column field="disposalOperator" title="操作人" show-overflow="title"></vxe-table-column>
                                <vxe-table-column field="updatedTime" title="操作时间" show-overflow="title"></vxe-table-column>
                            </vxe-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <vodal :show="isShowSource" :width="600" :height="400" :duration="300" :closeOnClickMask="false" animation="zoom" @hide="isShowSource = false">
            <vxe-table show-overflow highlight-hover-row highlight-current-row auto-resize border="none" class="mytable-scrollbar" height="100%" :data="hwSourceList"
                empty-text="暂无数据！" ref="xTable">
                <vxe-table-column type="seq" width="60"></vxe-table-column>
                <vxe-table-column width="80" field="name" title="来源" show-overflow="title"></vxe-table-column>
                <vxe-table-column width="100" field="realName" title="联系人" show-overflow="title"></vxe-table-column>
                <vxe-table-column width="120" field="phone" title="联系电话" show-overflow="title"></vxe-table-column>
                <vxe-table-column field="address" title="详细地址" show-overflow="title"></vxe-table-column>
            </vxe-table>
        </vodal>
    </div>
</template>
<script>
/* eslint-disable */
import layer from "layui-layer";
import Enum from "../../enum/enum.js";
import EventBus from "../js/event-bus";
import EnterpriseHwType from "./EnterpriseHwType";
import EnterpriseComparison from "./EnterpriseComparison";
import EnterpriseFlowDirection from "./EnterpriseFlowDirection";
import EnterpriseForecast from "./EnterpriseForecast";
import EnterpriseFlowChart from "./EnterpriseFlowChart";
import Step from "../step/Step.vue";
import Vodal from "../dialog/Vodal";

export default {
    components: {
        EnterpriseHwType,
        EnterpriseComparison,
        EnterpriseFlowDirection,
        EnterpriseForecast,
        EnterpriseFlowChart,
        Step,
        Vodal,
    },
    name: "EnterpriseDetail",
    data() {
        return {
            enum: Enum,
            organizationId: 0,
            tabIndex: 0,
            lifeIndex: 0,
            standingBookIndex: 0,
            enterpriseInfo: {},
            cameraList: null,
            hwTypeList: null,
            hwSourceList: null,
            currentHwType: null,
            standingBookList1: null,
            standingBookList2: null,
            standingBookList3: null,
            storeHouse: {},
            alarmList: [],
            currentAlarm: null,
            isShowSource: false,
            alarmStatus: [
                {
                    text: "待响应",
                    active: true,
                },
                {
                    text: "已响应",
                },
                {
                    text: "处理中",
                },
                {
                    text: "已处理",
                },
            ],
            alarmLogs: [],
            manifestList: [],
            currentManifest: null,
            manifestStatus: [
                {
                    text: "联单申请",
                    active: true,
                },
                {
                    text: "运输确认",
                },
                {
                    text: "联单运输",
                },
                {
                    text: "确认到达",
                },
                {
                    text: "联单完结",
                },
            ],
            manifestLogs: [],
            imageList: [],
        };
    },
    mounted() {
        EventBus.$on(
            "showOrganizationDetail",
            (organizationId, tabIndex = 0) => {
                if (!organizationId) {
                    return;
                }
                this.tabIndex = tabIndex;
                this.organizationId = organizationId;
                this.getOrganization(organizationId);
                this.getCamerasByOrganization(organizationId);
                this.getTopByOrganization(organizationId, 21);
                this.getInventory(organizationId);
                this.getFirstByOrganization(organizationId);
                this.getAlarmList(organizationId);
                this.getManifestList(organizationId);
            }
        );
        EventBus.$on("heartbeat", (value) => {
            if (!value) {
                return;
            }
            this.storeHouse = value;
        });
    },
    methods: {
        changeTab(index) {
            this.tabIndex = index;
            if (index == 9) {
                this.changeStandingBook(0);
            }
        },
        changeLife(index) {
            this.lifeIndex = index;
            this.sendFlowChartEvent();
        },
        changeStandingBook(index) {
            this.standingBookIndex = index;
            switch (index) {
                case 0:
                    this.getStandingBookInStorage();
                    break;
                case 1:
                    this.getStandingBookTransfer();
                    break;
                case 2:
                    this.getStandingBookDisposal();
                    break;
            }
        },
        lifeClickEvent({ row }) {
            this.currentHwType = row;
            this.sendFlowChartEvent();
        },
        alarmClickEvent({ row }) {
            this.currentAlarm = row;
            this.getAlarmLog();
        },
        manifestClickEvent({ row }) {
            this.currentManifest = row;
            this.getManifestLog();
        },
        getOrganization(organizationId) {
            this.organizationInfo = {};
            this.$api
                .getOrganization(organizationId)
                .then((result) => {
                    if (result.ok === true) {
                        this.enterpriseInfo = result.data;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getCamerasByOrganization(organizationId) {
            this.cameraInfo = null;
            this.$api
                .getCamerasByOrganization(organizationId)
                .then((result) => {
                    if (result.ok === true) {
                        this.cameraList = result.data;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getTopByOrganization(organizationId, n) {
            this.imageList = [];
            this.$api
                .getTopByOrganization(organizationId, n)
                .then((result) => {
                    if (result.ok === true) {
                        this.imageList = result.data;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getInventory(organizationId) {
            this.$api
                .getInventory(organizationId)
                .then((result) => {
                    if (result.ok === true) {
                        this.hwTypeList = result.data;
                        if (result.data && result.data.length > 0) {
                            this.currentHwType = result.data[0];
                            this.$refs.xTable.setCurrentRow(this.currentHwType);
                            this.sendFlowChartEvent();
                        }
                    } else {
                        console.log("请求失败!");
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getFirstByOrganization(organizationId) {
            this.$api
                .getFirstByOrganization(organizationId)
                .then((result) => {
                    if (result.ok === true) {
                        this.storeHouse = result.data;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getAlarmList(organizationId) {
            this.alarmList = null;
            this.$api
                .getAlarmList(organizationId)
                .then((result) => {
                    if (result.ok === true) {
                        this.alarmList = result.data.items;
                        if (this.alarmList && this.alarmList.length > 0) {
                            this.currentAlarm = this.alarmList[0];
                            this.getAlarmLog();
                        } else {
                            this.alarmLogs = null;
                            this.currentAlarm = null;
                        }
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getAlarmLog() {
            this.alarmLogs = null;
            if (!this.currentAlarm) {
                return;
            }
            // 重置状态
            this.alarmStatus.forEach((x) => {
                x.active = false;
            });

            for (var i = 0; i <= this.currentAlarm.status; i++) {
                this.alarmStatus[i].active = true;
            }

            // 获取日志
            this.$api
                .getAlarmLifeCycleLogs(this.currentAlarm.alarmId)
                .then((result) => {
                    if (result.ok === true) {
                        this.alarmLogs = result.data;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getHwSource(ids) {
            // 获取日志
            this.$api
                .getHwSourceList(ids)
                .then((result) => {
                    if (result.ok === true) {
                        this.hwSourceList = result.data;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getManifestList(organizationId) {
            this.$api
                .getManifestList(organizationId)
                .then((result) => {
                    if (result.ok === true) {
                        this.manifestList = result.data.items;
                        if (this.manifestList && this.manifestList.length > 0) {
                            this.currentManifest = this.manifestList[0];
                            this.getManifestLog();
                        } else {
                            this.manifestLogs = null;
                            this.currentManifest = null;
                        }
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getManifestLog() {
            this.manifestLogs = null;
            if (!this.currentManifest) {
                return;
            }
            // 重置状态
            this.manifestStatus.forEach((x) => {
                x.active = false;
            });

            var type = 0;
            if (
                this.currentManifest.lifeCycle > 1 &&
                this.currentManifest.lifeCycle < 8
            ) {
                type = 2;
            } else if (
                this.currentManifest.lifeCycle >= 8 &&
                this.currentManifest.lifeCycle < 10
            ) {
                type = 3;
            } else if (this.currentManifest.lifeCycle == 10) {
                type = 4;
            }

            for (var i = 0; i <= type; i++) {
                this.manifestStatus[i].active = true;
            }

            // 获取日志
            this.$api
                .getManifestLifeCycleLogs(this.currentManifest.hwManifestId)
                .then((result) => {
                    if (result.ok === true) {
                        this.manifestLogs = result.data;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        sendFlowChartEvent() {
            // 发送更新流程图事件
            EventBus.$emit(
                "changeFlowChart",
                this.organizationId,
                this.currentHwType ? this.currentHwType.hwCode2 : null,
                this.lifeIndex + 1,
                this.currentHwType ? this.currentHwType.alias : null
            );
        },
        openVideo(item) {
            layer.open({
                type: 2,
                title: false,
                closeBtn: true,
                shade: 0.8,
                scrollbar: false,
                skin: "dialog-bg-transparent",
                area: ["893px", "600px"],
                content: "/page/video.html",
                success: (layero, index) => {
                    var iframeWin = window[layero.find("iframe")[0]["name"]];
                    iframeWin.layerData({
                        serialNo: item.serialNo,
                        accessToken: item.accessToken,
                    });
                },
            });
        },
        openTrack(item) {
            layer.open({
                type: 2,
                title: false,
                closeBtn: true,
                shade: 0.8,
                scrollbar: false,
                skin: "dialog-bg-transparent",
                area: ["1400px", "800px"],
                content: "/page/mapTrack.html",
                success: (layero, index) => {
                    var iframeWin = window[layero.find("iframe")[0]["name"]];
                    iframeWin.layerData(item);
                },
            });
        },
        openSource(item) {
            this.getHwSource(item.hwSourceIds);
            this.isShowSource = true;
        },
        imageView(url) {
            layer.open({
                type: 2,
                title: false,
                closeBtn: true,
                shade: 0.8,
                scrollbar: false,
                skin: "dialog-bg-transparent",
                area: ["900px", "600px"],
                content: "./page/imageView.html",
                success: function (layero, index) {
                    var iframeWin = window[layero.find("iframe")[0]["name"]];
                    iframeWin.layerData(url);
                },
            });
        },
        getStandingBookDisposal() {
            this.$api
                .getStandingBookDisposal(this.organizationId)
                .then((result) => {
                    if (result.ok === true) {
                        this.standingBookList3 = result.data;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getStandingBookTransfer() {
            this.$api
                .getStandingBookTransfer(this.organizationId)
                .then((result) => {
                    if (result.ok === true) {
                        this.standingBookList2 = result.data;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getStandingBookInStorage() {
            this.$api
                .getStandingBookInStorage(this.organizationId)
                .then((result) => {
                    if (result.ok === true) {
                        this.standingBookList1 = result.data;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
</script>
<style lang="less">
.enterise-detail-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;

    .top-container {
        width: 100%;
        height: 20%;
        display: flex;
        flex-direction: row;
        margin-bottom: 15px;

        .header-left {
            width: 80%;
            height: 100%;
            margin-right: 15px;
            display: flex;
            flex-direction: column;

            .field-container {
                flex: auto;
                width: 100%;
                background-color: #131654;
                display: flex;
                flex-direction: row;
                justify-content: space-around;

                .field-row {
                    width: 30%;
                    margin: 10px 0;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    font-size: 14px;
                }
            }
        }

        .header-right {
            flex: auto;
            height: 100%;
            display: flex;
            flex-direction: column;

            .video-container {
                flex: auto;
                width: 100%;
                background-color: #131654;
                display: flex;
                flex-direction: row;
                justify-content: space-around;
                align-items: center;

                .video-item {
                    text-align: center;
                    font-size: 14px;

                    .videl-title {
                        margin-top: 10px;
                    }
                }
            }
        }
    }

    .bottom-container {
        width: 100%;
        flex: auto;
        display: flex;
        flex-direction: column;

        .tab-header {
            width: 100%;
            background-color: #131654;
            display: flex;
            flex-direction: row;
            font-size: 14px;
            margin-bottom: 15px;
            border: none;

            .tab-devider {
                width: 1px;
                height: 50px;
                //background-color: #131654;
                background-color: #161a6b;
            }

            .tab-item {
                width: 100px;
                height: 50px;
                justify-content: center;
                align-items: center;
                display: flex;
                //background-color: #161a6b;
                background-color: #131654;
                cursor: pointer;
            }

            .tab-item-active {
                background-color: #f1485b;
            }
        }

        .tab-container {
            width: 100%;
            height: 560px;
            background-color: #100c2a;

            .tab-life {
                width: 100%;
                height: 100%;
                display: flex;

                .life-left {
                    width: 30%;
                    height: 100%;
                    margin-right: 15px;
                }

                .life-right {
                    //width: 60%;
                    flex: auto;
                    height: 100%;
                    background-color: #131654;

                    .life-right-header {
                        height: 12%;
                        display: flex;
                        justify-content: left;
                        text-align: center;

                        .life-right-header-btn1 {
                            width: 42px;
                            height: 42px;
                            margin: auto 10px;
                            text-align: center;
                            line-height: 42px;
                            border-radius: 42px;
                            font-size: 14px;
                            background-color: orangered;
                            cursor: pointer;
                            color: white;
                            opacity: 0.5;
                            border: 2px solid #100c2a;
                        }

                        .life-right-header-btn2 {
                            width: 42px;
                            height: 42px;
                            margin: auto 10px;
                            text-align: center;
                            line-height: 42px;
                            border-radius: 42px;
                            font-size: 14px;
                            background-color: orange;
                            cursor: pointer;
                            color: white;
                            opacity: 0.5;
                            border: 2px solid #100c2a;
                        }

                        .life-right-header-btn3 {
                            width: 42px;
                            height: 42px;
                            margin: auto 10px;
                            text-align: center;
                            line-height: 42px;
                            border-radius: 42px;
                            font-size: 14px;
                            background-color: darkcyan;
                            cursor: pointer;
                            color: white;
                            opacity: 0.5;
                            border: 2px solid #100c2a;
                        }

                        .life-right-header-btn4 {
                            width: 42px;
                            height: 42px;
                            margin: auto 10px;
                            text-align: center;
                            line-height: 42px;
                            border-radius: 42px;
                            font-size: 14px;
                            background-color: green;
                            cursor: pointer;
                            color: white;
                            opacity: 0.5;
                            border: 2px solid #100c2a;
                        }

                        .life-right-header-icon {
                            margin: auto 20px;
                            text-align: center;
                            font-size: 28px;
                        }
                    }

                    .life-right-content {
                        flex: auto;
                        height: 85%;
                    }
                }
            }

            .tab-store {
                width: 100%;
                height: 100%;
                display: flex;

                .store-left {
                    width: 30%;
                    height: 100%;
                    margin-right: 15px;
                    background-color: #131654;

                    .store-body {
                        padding: 20px;

                        table {
                            line-height: 34px;
                            font-size: 14px;
                        }
                    }
                }

                .store-right {
                    flex: auto;
                    height: 100%;
                    background-color: #131654;
                    display: flex;
                    flex-direction: column;
                }
            }

            .tab-alarm {
                width: 100%;
                height: 100%;
                display: flex;

                .alarm-left {
                    width: 65%;
                    height: 100%;
                    margin-right: 15px;
                    background-color: #131654;
                    display: flex;
                    flex-direction: column;
                }

                .alarm-right {
                    width: 35%;
                    height: 100%;
                    background-color: #131654;
                    display: flex;
                    flex-direction: column;
                }
            }

            .tab-manifest {
                width: 100%;
                height: 100%;
                display: flex;

                .manifest-left {
                    width: 65%;
                    height: 100%;
                    margin-right: 15px;
                    background-color: #131654;
                    display: flex;
                    flex-direction: column;
                }

                .manifest-right {
                    //flex: auto;
                    width: 35%;
                    height: 100%;
                    background-color: #131654;
                    display: flex;
                    flex-direction: column;
                }
            }

            .tab-images {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;

                .image-item {
                    width: 220px;
                    height: 165px;
                    margin: 10px;

                    img {
                        width: 100%;
                        height: 100%;
                        border-radius: 5px;
                        border: 1px solid transparent;
                    }

                    img:hover {
                        border: 1px solid #168fbe;
                        cursor: pointer;
                    }
                }
            }

            .tab-chart {
                display: flex;
                justify-content: center;
                text-align: center;
            }
        }
    }
}

.title-container {
    margin-bottom: 15px;
}

.title-font {
    font-size: 20px;
    color: #19d1ff;
}

.prefix-line {
    border: 2px solid #3ca6fc;
    margin-right: 10px;
    border-radius: 3px;
}

.life-btn-active {
    border: 2px solid #ffffff !important;
    opacity: 1 !important;
}

.tab-body-header {
    height: 42px;
    line-height: 42px;
    padding: 0 15px;
    border-bottom: 1px solid #ffffff;
    font-size: 14px;
}
.long-text-span {
    display: block;
    word-break: keep-all;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    -icab-text-overflow: ellipsis;
    -khtml-text-overflow: ellipsis;
    -moz-text-overflow: ellipsis;
    -webkit-text-overflow: ellipsis;
}
</style>
